import LegalLayout from "@/components/legal/LegalLayout";
import { useSeo } from "@/lib/seo";
import { Envelope, Clock, MapPin, Headset, Handshake } from "@phosphor-icons/react";

export default function ContactUs() {
  useSeo({
    title: "Contact Us – QuickDukaan",
    description: "Get in touch with QuickDukaan for customer support, business partnerships and seller queries.",
    path: "/contact-us",
  });

  return (
    <LegalLayout
      testid="contact-page"
      title="Contact Us"
      intro="We’re here to help. For any questions, feedback, support requests, or business inquiries, reach out through the channels below."
      crumbs={[{ label: "Contact Us" }]}
    >
      <div className="grid sm:grid-cols-2 gap-4 mt-2">
        <ContactCard
          icon={Headset}
          title="Customer Support"
          subtitle="Help with orders, deliveries, account & app issues."
          email="support@quickdukaan.in"
          testid="contact-support"
        />
        <ContactCard
          icon={Handshake}
          title="Business & Seller Partnerships"
          subtitle="Open your store on QuickDukaan or explore partnerships."
          email="partnerships@quickdukaan.in"
          testid="contact-partnerships"
        />
      </div>

      <div className="mt-6 grid sm:grid-cols-2 gap-4">
        <div className="qd-card p-5">
          <div className="flex items-center gap-2 text-[#15803D] font-heading font-black text-base">
            <Clock weight="duotone" size={20} /> Operating Hours
          </div>
          <p className="text-sm text-gray-700 mt-2">Monday to Sunday</p>
          <p className="font-heading font-black text-lg">9:00 AM – 9:00 PM <span className="text-sm font-bold text-gray-500">IST</span></p>
        </div>
        <div className="qd-card p-5">
          <div className="flex items-center gap-2 text-[#15803D] font-heading font-black text-base">
            <MapPin weight="duotone" size={20} /> Service Availability
          </div>
          <p className="text-sm text-gray-700 mt-2">
            QuickDukaan is currently operating in selected areas and expanding gradually. Product availability and delivery timelines may vary based on location and participating stores.
          </p>
        </div>
      </div>

      <div className="mt-10 rounded-2xl bg-[#F8CB46]/15 p-5 sm:p-6">
        <h2 className="font-heading font-black text-xl">Prefer email?</h2>
        <p className="text-sm text-gray-700 mt-1">
          The fastest way to reach us is by email — we typically respond within one working day.
        </p>
        <a href="mailto:support@quickdukaan.in"
          className="inline-flex items-center gap-2 mt-4 bg-[#15803D] text-white font-bold text-sm px-4 py-2.5 rounded-full hover:bg-[#166534] transition active:scale-95"
          data-testid="contact-email-cta">
          <Envelope weight="fill" size={16} /> Email support@quickdukaan.in
        </a>
      </div>
    </LegalLayout>
  );
}

function ContactCard({ icon: Icon, title, subtitle, email, testid }) {
  return (
    <div className="qd-card p-5 flex flex-col" data-testid={testid}>
      <div className="flex items-center gap-2">
        <span className="w-10 h-10 rounded-xl bg-[#15803D]/10 flex items-center justify-center text-[#15803D]">
          <Icon weight="duotone" size={20} />
        </span>
        <h2 className="font-heading font-black text-lg">{title}</h2>
      </div>
      <p className="text-sm text-gray-600 mt-2">{subtitle}</p>
      <a href={`mailto:${email}`} className="mt-3 inline-flex items-center gap-1.5 text-[#15803D] font-bold text-sm group">
        <Envelope size={14} weight="duotone" />
        <span className="group-hover:underline underline-offset-2">{email}</span>
      </a>
    </div>
  );
}
